import { Box } from '@mui/material';
import './App.css';
import { Header, HomePage } from './components';
import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './components/firebase';
import Footer from './components/Footer';

async function generateToken(email) {
  const secretKey = process.env.REACT_APP_ATS_SECRET_KEY;
  if (!secretKey) {
    console.warn("REACT_APP_ATS_SECRET_KEY is not set — auth will likely fail.");
    return btoa(email);
  }
  const encoder = new TextEncoder();
  const key = await window.crypto.subtle.importKey(
    'raw',
    encoder.encode(secretKey),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );
  const sig = await window.crypto.subtle.sign('HMAC', key, encoder.encode(email));
  return Array.from(new Uint8Array(sig))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

function App() {
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [signInOpen, setSignInOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUserName(currentUser.displayName);
        setIsSignedIn(true);
        const userEmail = currentUser.email;
        const userToken = await generateToken(userEmail);
        setToken(userToken);
        setEmail(userEmail);
      } else {
        setIsSignedIn(false);
        setToken("");
        setEmail("");
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <Box sx={{ background: (theme) => theme.palette.grey['300'] }}>
      <Header
        isSignedIn={isSignedIn}
        userName={userName}
        signInOpen={signInOpen}
        setSignInOpen={setSignInOpen}
      />
      <HomePage
        isSignedIn={isSignedIn}
        email={email}
        token={token}
        setSignInOpen={setSignInOpen}
      />
      <Footer />
    </Box>
  );
}

export default App;
